export default {
    search: 'Search',
    associate: 'Associate',
}
